"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _6CXWEW5Ocjs = require('../__chunks/6CXWEW5O.cjs');
require('../__chunks/LH55DG7M.cjs');
require('../__chunks/XRATBFDX.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-group.tsx
var TagName = "div";
var useSelectGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectGroup2(props) {
    props = _6CXWEW5Ocjs.useCompositeGroup.call(void 0, props);
    return props;
  }
);
var SelectGroup = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectGroup2(props) {
  const htmlProps = useSelectGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.SelectGroup = SelectGroup; exports.useSelectGroup = useSelectGroup;
